/*
 * @Author: your name
 * @Date: 2021-01-28 16:20:15
 * @LastEditTime: 2021-05-07 11:39:04
 * @LastEditors: wangshengqiang
 * @Description: In User Settings Edit
 * @FilePath: /za-dplatform-product-life/Users/zhongan/project/za-dplatform-main/za-dplatform-h5/src/constant/index.js
 */

/* eslint-disable import/prefer-default-export */
export * from './storeKey.js';
export const OCCUPATION_CATEGORY_MAP = {
  category1: '1类',
  category2: '2类',
  category3: '3类',
  category4: '4类',
  category5: '5类',
  category6: '6类',
  category7: '7类'
};
export const POSTMESSAGE_PARAMS = '*';
export const CERT_TYPE_LIST = [{
  code: "CERT",
  name: "身份证",
  short: "I"
}, {
  code: "HOUSEhHOLD",
  name: "户口本",
  short: "H"
}, {
  code: "DRIVENLICENSE",
  name: "驾照",
  short: "D"
}, {
  code: "MILITARYCARD",
  name: "军官证",
  short: "M"
}, {
  code: "PASSPORT",
  name: "护照",
  short: "P"
}, {
  code: "RETURNHOME",
  name: "返乡证",
  short: "GJ"
}, {
  code: "TAIWAN",
  name: "台胞证/台湾居民来往大陆通行证",
  short: "TB"
}, {
  code: "HONGKONGMACAO",
  name: "大陆居民往来港澳通行证",
  short: "GA"
}, {
  code: "STUDENT",
  name: "学生证",
  short: "X"
}, {
  code: "SOLIDER",
  name: "士兵证",
  short: "S"
}, {
  code: "BIRTH",
  name: "出生证",
  short: "B"
}, {
  code: "TAIWAN_TRAVEL",
  name: "大陆居民往来台湾通行证",
  short: "TW"
}, {
  code: "SEAFARER",
  name: "国际海员证",
  short: "G"
}, {
  code: "FOREIGN_PERMANENT",
  name: "外国人永久居留证",
  short: "J"
}, {
  code: "TRAVEL",
  name: "旅行证",
  short: "LX"
}, {
  code: "TAIWAN_ID",
  name: "台湾身份证",
  short: "TWI"
}, {
  code: "MACAO_ID",
  name: "澳门居民身份证",
  short: "BIR"
}, {
  code: "HONGKONG_ID",
  name: "香港身份证",
  short: "HKI"
}, {
  code: "Q",
  name: "其他",
  short: "Q"
}, {
  code: "POLICE",
  name: "警官证",
  short: null
}, {
  code: "FOREIGN",
  name: "外国人居留证",
  short: null
}, {
  code: "RETIRE",
  name: "军官退休证",
  short: null
}, {
  code: "PERMIT_FOR_HONGKONGMACAO",
  name: "港澳居民来往内地通行证",
  short: null
}, {
  code: "T",
  name: "税务登记证",
  short: null
}, {
  code: "L",
  name: "营业执照",
  short: null
}, {
  code: "Z",
  name: "组织机构代码",
  short: null
}, {
  code: "U",
  name: "统一社会信用代码",
  short: null
}, {
  code: "HOUSE_HOLD",
  name: "户口本",
  short: null
}, {
  code: "TEMPORARY_CERT",
  name: "临时身份证",
  short: null
}, {
  code: "HK_MACAO_RESIDENCE_PERMIT",
  name: "港澳居民居住证",
  short: null
}, {
  code: "TAIWAN_RESIDENCE_PERMIT",
  name: "台湾居民居住证",
  short: null
}];